import { createContext, useContext, useEffect } from 'react';

/**
 * Store mode (22 Oct 2026): while a vendor store's own page is open
 * (/<handle>, /<handle>/<slug>), App swaps the Zaynic navbar/footer for a
 * slim "on Zaynic" bar and a "Sold by <store> · Powered by Zaynic" footer.
 * The house store (Zaynic itself) keeps the normal chrome.
 */
export const StoreModeContext = createContext({ store: null, setStore: () => {} });

export function useStoreMode() {
  return useContext(StoreModeContext);
}

/** Turn store mode on for `store` while the calling page is mounted. */
export function useActivateStoreMode(store) {
  const { setStore } = useStoreMode();
  const active = store && !store.is_house ? store : null;
  useEffect(() => {
    setStore(active);
  }, [active, setStore]);
  useEffect(() => () => setStore(null), [setStore]);
}
